// Оболочка, для задания options
import VueMeta from 'vue-meta';

export default {
  install: (Vue) => {
    Vue.use(VueMeta, {
      keyName: 'metaInfo',
      attribute: 'data-vue-meta',
      ssrAttribute: 'data-vue-meta-server-rendered',
      tagIDKeyName: 'vmid',
      ssrAppId: 1,
      refreshOnceOnNavigation: true,
    });
  },
};
